import { JuloUpdateEntry } from "./types"

export const bedomningskortRedesignEntry: JuloUpdateEntry = {
  slug: "2026-05-13-bedomningskort-redesign",
  date: "2026-05-13",
  title: "Nytt utseende på komponentkorten i besiktningen",
  description:
    "Komponentkorten i besiktningen har fått en ny layout. Det viktigaste är att ni nu lägger till produkter på en åtgärd på samma sätt som när ni lägger till åtgärder och produkter i mottagningen — samma sökruta och samma flöde — så det känns konsekvent mellan vyerna. Även kommentar, kostnad och rabatt använder samma kontroller som i serviceförslagsvyn i mottagningen. Alternativgrupper (där ni rekommenderar en produkt med andra som alternativ) finns kvar, men ni skapar och redigerar dem nu direkt i kortet via ⋮-menyn istället för i en separat dialog.",
  images: [
    {
      src: "/julo-updates/2026-05-13-bedomningskort-redesign/komponentkort.png",
      alt: "Uppfällt komponentkort för Bromsklossar fram i besiktningen med skickreglage, åtgärdsknappar, kommentar- och kostnadsfält (309 kr med -10 % rabatt → 278 kr), sökrad för produkter, en alternativgrupp (Produktgrupp (2)) med Bromsklossar 1 (299 kr, -25 % → 224 kr, behöver beställas 20 maj 2026) och Bromsklossar 2 (99 kr), samt en öppen ⋮-meny med valen Lägg till rabatt, Behöver beställas och Ta bort produkt.",
    },
  ],
}
